/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdateOrganizationPaymentAddonUserOptionResponseDataFromJSON, UpdateOrganizationPaymentAddonUserOptionResponseDataToJSON } from './UpdateOrganizationPaymentAddonUserOptionResponseData';
export function UpdateOrganizationPaymentAddonUserOptionResponseFromJSON(json) {
    return UpdateOrganizationPaymentAddonUserOptionResponseFromJSONTyped(json, false);
}
export function UpdateOrganizationPaymentAddonUserOptionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: json['status'],
        data: UpdateOrganizationPaymentAddonUserOptionResponseDataFromJSON(json['data'])
    };
}
export function UpdateOrganizationPaymentAddonUserOptionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: UpdateOrganizationPaymentAddonUserOptionResponseDataToJSON(value.data)
    };
}
